module.exports = __webpack_public_path__ + "static/talks-and-courses-e045d263ffa886fefd7c57334da94e5c.jpeg";